import { startCase } from 'lodash'

export const resignationFilters = [
  {
    label: 'Resignation Date',
    value: 'resignation_date',
    component: 'datePickerWrapper'
  },
  {
    label: 'Resigned By',
    value: 'resigned_by',
    userSearchable: true,
    isMulti: true,
    component: 'selectWrapper'
  },
  {
    label: 'Resigned on date range',
    value: 'resigned_on_date_range',
    fromDateValue: 'resigned_on_from_date',
    toDateValue: 'resigned_on_to_date',
    component: 'dateRangePickerWrapper'
  },
  {
    label: 'Proposed LWD',
    value: 'proposed_lwd',
    component: 'datePickerWrapper'
  },
  {
    label: 'Last Working Date',
    value: 'last_working_date',
    component: 'datePickerWrapper'
  },
  {
    label: 'Resignation Timeline Status',
    value: 'timeline_statuses',
    placeholder: 'Select Status(s)',
    multiOption: true,
    allCheck: true,
    component: 'selectWrapper'
  }
]

export const resignationStatuses = [
  { label: 'Pending Lead', value: 'pending_lead' },
  { label: 'Pending PM', value: 'pending_pm' },
  { label: 'Pending Departmental Approval', value: 'pending_departmental_approval' },
  { label: 'Pending Hr', value: 'pending_hr' },
  { label: 'Pending Cluster Head', value: 'pending_cluster_head' },
  { label: 'Pending User Approval', value: 'pending_user_approval' }
]

export const resignationTimelineStatuses = [
  { label: 'Accepted', value: 'accepted' },
  { label: 'Revoked', value: 'revoked' },
  { label: 'Archived', value: 'archived' }
]

export const resignationHeaders = [
  { name: 'Employee Name', sort_name: 'first_name' },
  { name: 'Resigned On', sort_name: 'resigned_on' },
  { name: 'Actual Last Working Date', sort_name: 'actual_lwd' },
  { name: 'Proposed Last Working Date', sort_name: 'proposed_lwd' },
  { name: 'Experience Letter (to be issued)', sort_name: 'experience_letter_required' },
  { name: 'Status', sort_name: 'status' },
  { name: 'Action', sort_name: null }
]

export const pendingResignationStatuses = [
  'pending_lead',
  'pending_pm',
  'pending_departmental_approval',
  'pending_hr',
  'pending_cluster_head',
  'pending_user_approval'
]

export const approvedResignationStatuses = [
  'lead_endorsed',
  'manager_approved',
  'ha_acknowledged',
  'department_approved',
  'cluster_head_approved',
  'user_approved'
]

export const ResignationTimelineStatusAction = (status) => {
  if (pendingResignationStatuses.includes(status)) return 'Pending'
  else if (approvedResignationStatuses.includes(status)) return 'Approved'
}

export const ResignationTimelineText = (status, dynamic_approval_title) => {
  switch (status) {
    case 'pending_lead':
      return 'Lead'
    case 'pending_pm':
      return 'Project Manager'
    case 'pending_cluster_head':
      return 'Cluster Head'
    case 'pending_departmental_approval':
      return `Department ${dynamic_approval_title ? `(${dynamic_approval_title})` : ''}`
    case 'pending_hr':
      return `Pending HR ${dynamic_approval_title ? `(${dynamic_approval_title})` : ''}`
    case 'lead_endorsed':
      return 'Lead Endorsed'
    case 'manager_approved':
      return 'Manager Approved'
    case 'cluster_head_approved':
      return 'Cluster Head Approved'
    case 'ha_acknowledged':
      return `HA Acknowledged ${dynamic_approval_title ? `(${dynamic_approval_title})` : ''}`
    case 'department_approved':
      return `Department Approved ${dynamic_approval_title ? `(${dynamic_approval_title})` : ''}`
    default:
      return startCase(status)
  }
}
export const transformResignationRevokeValues = (values) => {
  const revokeParams = {
    resignation_timeline_id: values.resignation_timeline_id,
    status: 'pending_revoke'
  }
  return revokeParams
}

export const transformResignationFormValues = (values, currentUser) => {
  const transformed = {
    ...values,
    exit_reason_id: values.exit_reason?.value,
    user_id: currentUser.id
  }
  delete transformed.exit_reason
  delete transformed.notice_period_months
  return transformed
}

export const offboardingDependenciesTableHeaders = ['ID', 'Name', 'Description', 'Actions']

export const timelinePendingStatuses = ['pending', 'pending_revoke']

export const timelinePendingOrAcceptedStatuses = [...timelinePendingStatuses, 'accepted']

export const resignationStatusBadgeVariant = (status) => (status === 'archived' ? 'blue' : 'primary')

const resignationRequestStatuses = {
  pending: { label: 'Request Pending', variant: 'pending' },
  pending_revoke: { label: 'Revoke Requested', variant: 'pending' },
  accepted: { label: 'Request Approved', variant: 'approved' },
  revoked: { label: 'Request Revoked', variant: 'revoked' },
  archived: { label: 'Request Archived', variant: 'archived' },
  cancelled: { label: 'Offboarding Cancelled', variant: 'archived' },
  discarded: { label: 'Request Discarded', variant: 'archived' }
}

const REVOKE_DIVIDER = 'Revoke Process Initiated'

const approvalGroupDividers = {
  'Resignation Revoked!': REVOKE_DIVIDER,
  'Approval reinitiated': 'Approval Process Re-initiated',
  'User offboarding cancelled!': 'Offboarding Cancelled'
}

const approvalGroupDivider = (approvals, index) => {
  const previousComment = approvals[index - 1]?.comment

  return approvals[index]?.comment === previousComment ? undefined : approvalGroupDividers[previousComment]
}

const groupStatusKey = (closingDivider, activeStatus) => {
  if (closingDivider === REVOKE_DIVIDER) return 'revoked'
  if (closingDivider) return 'discarded'

  return activeStatus
}

export const resignationApprovalGroups = (approvals = [], activeStatus) => {
  const groups = []

  approvals.forEach((approval, index) => {
    const divider = approvalGroupDivider(approvals, index)
    if (!groups.length || divider) groups.push({ divider, approvals: [] })
    groups[groups.length - 1].approvals.push(approval)
  })

  return groups.map((group, index) => {
    const statusKey = groupStatusKey(groups[index + 1]?.divider, activeStatus)
    const status = resignationRequestStatuses[statusKey] || resignationRequestStatuses.archived

    return { ...group, status, collapsed: status.variant !== 'pending' }
  })
}
